import { lazy, Suspense, useEffect, useState } from 'react';

const RevealObserver = lazy(() => import('./RevealObserver'));

/** Mount scroll-reveal after first paint / idle to reduce main-thread work during LCP. */
export default function DeferredRevealObserver() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const mount = () => setShow(true);
    if ('requestIdleCallback' in window) {
      const id = requestIdleCallback(mount, { timeout: 1500 });
      return () => cancelIdleCallback(id);
    }
    const t = setTimeout(mount, 1);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;
  return (
    <Suspense fallback={null}>
      <RevealObserver />
    </Suspense>
  );
}
